import useToggleLocalMute from '@hooks/sdk/useToggleLocalMute';
import type { FC } from 'react';
import { Container, IconWrapper } from './style';
import MicIcon from '/icon/mike.svg';

const MicToggle: FC = () => {
  const { muted, toggleMute } = useToggleLocalMute();

  return (
    <Container onClick={toggleMute} isActive={!muted}>
      <IconWrapper>
        <img src={MicIcon} />
      </IconWrapper>
      <span>마이크</span>
    </Container>
  );
};

export default MicToggle;
